import { Popover, Tooltip } from "antd";
import React, { useState } from "react";
import { HiMiniLanguage } from "react-icons/hi2";
import Languages from "../helpers/languages.json";
import "../styles.scss";
import i18next from "i18next";
import { setDirection } from "../../../redux/slices/languageSlice";
import { useDispatch } from "react-redux";
import API from "../../../config/API";

const LanguageSelector = (props: any) => {
  const [selected, setselected] = useState("EN");
  const lang = <span>Language</span>;
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const handleChangeLanguage = (value: any) => {
    if (value === "ar") {
      dispatch(setDirection("RTL"));
    } else {
      dispatch(setDirection("LTR"));
    }

    setselected(value.toUpperCase());
    const language = value;
    i18next.changeLanguage(language);
  };

  const languages = (
    <div>
      {Languages?.map((val: any) => (
        <div
          key={val.id}
          className="language-txt1"
          onClick={() => {
            hide();
            handleChangeLanguage(val.value);
          }}
        >
          {val.title}
        </div>
      ))}
    </div>
  );
  return (
    <div>
      <Popover
        open={open}
        placement="bottomRight"
        content={languages}
        trigger="click"
        onOpenChange={handleOpenChange}
        arrow={false}
      >
        <div className="hideMob">
        <div className="Header-IconCursor">
          <div className="Language-icon">
            <div>{selected}</div>
            <div style={{ margin: 4 }} />
            <Tooltip placement="top" title={lang}>
            <HiMiniLanguage size={20} className="HeadeIcon-cursor" color="#FCDDEC"/>
            </Tooltip>
          </div>
        </div>
        </div>
        <div className="hidedesk">
          <div className="Sidebar-itemBox">
            <HiMiniLanguage size={27} color="#fff" />
            <span>Language - {selected}</span>
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default LanguageSelector;
